export default __webpack_public_path__ + "static/media/group-3-mobile-img4.2268ccb7.png";